module.exports = __webpack_public_path__ + "static/media/perfect-gold_00001.20f5fab6.png";